import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkSandaig = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("SANDAIG"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Sandaig</a></h2>
      <p className="walk-text">Famous as the place Gavin Maxwell lived with his otters in his book ‘Ring of Bright Water’. This is a magical place. Sandy beaches, tidal islands to explore and a rope bridge for the kids!  
      </p>                                            
    </div>
  );
}

export default WalkSandaig
